<template>
  <router-view />
  <jl-alert />
</template>

<script>
export default {
  created() {
      this.check();
  },
  methods: {
      async check() {
          await this.$axios.get('/check');
      }
  },
}
</script>

<style>
:root {
    --primary-color: #e43834;
    --sub-color: #a92522;
    scroll-behavior: unset !important;
}

*,*::before,*::after {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html, body, #app {
  height: 100%;
}

.flex-1 {
  flex: 1;
}

.flex-0 {
  flex: 0 !important;
}

.navbar-brand, a {
  cursor: pointer;
}

.nav-link.active {
    background-color: #3c3c3c61;
}

.b-0 {
  border: 0;
}

.reference-sticky {
    position: sticky;
    top: 90px;
}

@media screen and (max-width: 767px) {
  .reference-sticky {
      position: relative;
      top: 0;
  }
}

.fw-100 {
  font-weight: 100;
}

.fw-200 {
  font-weight: 200;
}

.fw-300 {
  font-weight: 300;
}

.fw-400 {
  font-weight: 400;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.fw-700 {
  font-weight: 700;
}

.fw-800 {
  font-weight: 800;
}

.fw-900 {
  font-weight: 900;
}

.fs-10 {
  font-size: 10px;
}

.fs-12 {
  font-size: 12px;
}

.fs-14 {
  font-size: 14px;
}

.fs-16 {
  font-size: 16px;
}

.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

footer {
  min-height: 60px !important;
  max-height: 60px !important;
  height: 60px !important;
}

@media screen and (max-width: 976px) {
  .table-mobile {
    border: 0;
  }

  .table-mobile caption {
    font-size: 1.3em;
  }
  
  .table-mobile thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  
  .table-mobile tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  
  .table-mobile td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }
  
  .table-mobile td::before {
    /*
    * aria-label has no advantage, it won't be read inside a .table-mobile
    content: attr(aria-label);
    */
    content: attr(data-label);
    display: block;
    font-weight: bold;
    width: 100%;
    text-align: left;
    margin-bottom: 10px;
    text-transform: uppercase;
  }
  
  .table-mobile td:last-child {
    border-bottom: 0;
  }
}

.br-0 {
  border-radius: 0;
}

.cp {
  cursor: pointer;
}

</style>
